import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/axiosInstance";
import { useAuth } from "../../contexts/AuthContext";
import "@fontsource/oswald";
import HeaderBlue from "../../components/HeaderBlue";
import FooterBlue from "../../components/FooterBlue";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login, getDashboardRoute } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await api.post("/adminlogin", form);

      if (res.data && res.data.admin) {
        // Store admin data in context
        login(res.data.admin, res.data.token || res.data.success);

        // Get the appropriate dashboard route based on role
        const dashboardRoute = getDashboardRoute();

        console.log("Login successful");
        console.log("Role Name:", res.data.admin.role.roleName);
        console.log("Navigating to:", dashboardRoute);

        // Navigate to role-specific or default dashboard
        navigate(dashboardRoute);
      } else {
        setError(res.data?.message || "Invalid login credentials");
        setLoading(false);
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.response?.data?.message || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col font-oswald">
      <HeaderBlue />

      {/* Hero Section */}
      <section
        className="w-full py-60 relative"
        style={{
          backgroundImage: "url('./assets/adminsmall.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
        <div className="relative z-10 px-4 md:px-40"></div>
      </section>

      {/* Login Form */}
      <div className="flex items-center justify-center p-4 -mt-40 relative z-10 mb-10">
        <div className="w-full max-w-md p-8 rounded-lg shadow-xl border border-gray-300 bg-white transform transition-all duration-300 hover:shadow-2xl">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-primary mb-2">
              ADMIN LOGIN
            </h1>
            <p className="text-gray-600">Access your admin dashboard</p>
          </div>

          <form className="space-y-6" onSubmit={handleLogin}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email
              </label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-deep-red"
                placeholder="Enter your email"
                required
                disabled={loading}
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Password
              </label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-deep-red"
                placeholder="Enter your password"
                required
                disabled={loading}
              />
            </div>

            {error && (
              <div className="text-red-600 text-sm bg-red-50 p-2 rounded">
                {error}
              </div>
            )}

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 text-deep-red focus:ring-deep-red border-gray-300 rounded"
                  disabled={loading}
                />
                <label
                  htmlFor="remember-me"
                  className="ml-2 block text-sm text-gray-700"
                >
                  Remember me
                </label>
              </div>

              <div className="text-sm">
                <a
                  href=""
                  className="font-medium text-deep-red hover:text-deep-blue-dark transition"
                >
                  Forgot password?
                </a>
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-secondary text-white font-bold py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "LOGGING IN..." : "LOG IN"}
              </button>
            </div>
          </form>

          <div className="mt-6 text-center text-sm">
            <p className="text-gray-600">
              By logging into your account, you agree to our
              <a href="#" className="text-deep-red font-medium hover:underline">
                {" "}
                Terms of Use{" "}
              </a>
              and
              <a href="#" className="text-deep-red font-medium hover:underline">
                {" "}
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      <FooterBlue />
    </div>
  );
};

export default AdminLogin;
